import { useState } from "react";
import { faqs } from "@/mocks/heiliao";

const standards = [
  { icon: "ri-shield-check-line", title: "先定真伪，再谈站队", text: "有可核验信源互相印证才标「实锤」，其余一律保守标「存疑」。" },
  { icon: "ri-layout-grid-line", title: "给全上下文", text: "截图、录音尽量补前因后果，标注是否被二次加工，避免断章取义。" },
  { icon: "ri-refund-2-line", title: "错了就进「辟谣」", text: "被证伪的内容不删除，而是归档并标记反转，保留可查轨迹。" },
  { icon: "ri-user-line", title: "对人不对脸", text: "聚焦事实与口径差异，不做对个人生活与隐私的过度挖掘。" },
];

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100/70 py-10 md:py-16">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr]">
          <div className="flex flex-col">
            <div className="mb-1 flex items-center gap-2 text-xs font-bold tracking-widest text-accent-700">
              <i className="ri-lifebuoy-line text-sm"></i>吃瓜甄别手册
            </div>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              判断真假，别只靠一张图
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              这里是我们筛选证据时用的同一套标准。学会这些，你在别处刷到「大瓜」时也能自己先过一遍筛。
            </p>

            <div className="mt-6 space-y-3">
              {standards.map((s) => (
                <div key={s.title} className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3.5">
                  <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-100 text-base text-accent-800">
                    <i className={s.icon}></i>
                  </span>
                  <div>
                    <h3 className="font-bold text-foreground-950">{s.title}</h3>
                    <p className="mt-0.5 text-sm leading-6 text-foreground-600">{s.text}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 overflow-hidden rounded-xl bg-primary-500 px-5 py-6 text-background-50">
              <h3 className="font-heading text-lg font-black">手上有实锤却不知道怎么摆？</h3>
              <p className="mt-2 text-sm leading-6 text-background-50/90">
                把素材（截图、录音、链接）整理好，标注好时间与来源再发我们。我们不接匿名泼脏水，也不对未核实的单方说法站队。
              </p>
              <button className="mt-4 whitespace-nowrap rounded-full bg-background-50 px-5 py-2.5 text-sm font-bold text-primary-700 transition-transform hover:-translate-y-0.5">
                提交线索
                <i className="ri-arrow-right-up-line ml-1"></i>
              </button>
            </div>
          </div>

          <div>
            <div className="mb-1 flex items-center gap-2 text-xs font-bold tracking-widest text-primary-600">
              <i className="ri-question-answer-line text-sm"></i>常见疑问
            </div>
            <div className="mt-4 space-y-3">
              {faqs.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div
                    key={f.q}
                    className={
                      "overflow-hidden rounded-xl border bg-background-50 transition-colors " +
                      (isOpen ? "border-primary-300" : "border-background-200")
                    }
                  >
                    <button
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                    >
                      <span className="flex items-start gap-3">
                        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-xs font-black text-secondary-900">
                          {String(i + 1).padStart(2, "0")}
                        </span>
                        <span className="font-bold leading-6 text-foreground-950">{f.q}</span>
                      </span>
                      <i
                        className={
                          "shrink-0 text-lg text-primary-500 transition-transform " +
                          (isOpen ? "ri-subtract-line" : "ri-add-line")
                        }
                      ></i>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 pl-14 text-sm leading-7 text-foreground-600">{f.a}</div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}